export default {"src":"/_next/static/media/building.267eaa0c.svg","height":31,"width":28,"blurWidth":0,"blurHeight":0};